module.exports = __webpack_public_path__ + "img/wabutom.036cb42e.png";